import { Container, Row, Col } from "react-bootstrap";
import './deviceDetails.scss'
import './global.scss'
import {  MultiInput } from 'sfy-react'
import React, { useState, useEffect } from 'react'
import { postCoreRequestAsync } from "./genericApi";
import ButtonContainer from "./buttonContainer";
import ErrorModal from "./Modal/errorModal";
import pushToAnalytics, { getTimeDiff } from "./Analytics";
import './Container.scss'
const MobileOtpVerification = (props) => {
 const { changeScreen, currentIndex } = props;
 const mobileNumber = localStorage.getItem("ampleMobile")
 const [OtpError, setOtpError] = useState("");
 let [otpTimer, setTimer] = useState(20);
 const [resendRequest, setResendOtpFlag] = useState(false)
 const [showModal, setShowModal] = useState(false);
 const [otp, setOTP] = useState("");
 const [enterTime, setEnterTime] = useState(new Date())
 useEffect(() => {
  startTimer();
 }, [])
 useEffect(() => {
  if(otpTimer) setShowModal(true);
 }, [otpTimer])

 useEffect(() => {
  const currentTime = new Date();
  console.log("currentTime", currentTime)
  setEnterTime(currentTime);
  /* pushToAnalytics(
   'Basic Info - Verify OTP page',
   {
    url: 'https://clientstag-servicelee.servify.tech/'
   }
  )
 */
 }, [])
 useEffect(() => {
  if (resendRequest) startTimer();
 }, [resendRequest]);

 const startTimer = () => {
  let cIntID;
  cIntID = setInterval(() => {
   if (otpTimer === 1) clearInterval(cIntID)
   if (otpTimer >= 1) setTimer(otpTimer -= 1);
  }, 1000);
 }
 const on_verify_btn_click = async () => {
  setTimer(20);
  setOtpError("");
  try {
   let otpResponse = await postCoreRequestAsync('/api/Consumer/verifyOTP', { "MobileNo": mobileNumber, "Otp": otp, "CountryCode": "+91" })
   if (otpResponse && otpResponse.success && otpResponse.data && otpResponse.data.accessToken) {
    if(otpResponse.data.accessToken.id) localStorage.setItem("ampleAccessToken", otpResponse.data.accessToken.id)
    if(otpResponse.data.accessToken.ConsumerID) localStorage.setItem("ampleConsumerID", otpResponse.data.accessToken.ConsumerID)
   }
   pushToAnalytics(
    'Basic info - Verify OTP',
    {
     Unique_Key:localStorage.getItem('ampleUniquekey'),
     Time_Spent_On_Verify_OTP_Screen: getTimeDiff(new Date(), enterTime)
    }
   )

   changeScreen("deviceDetails");
   currentIndex(1);
  }
  catch (e) {
   console.log(e)
   if (e && !e.success && e.msg) setOtpError(e.msg)
  }
 }
 const on_back_btn_click = () => {
  setTimer(20);
  pushToAnalytics(
   'Basic info -  Back',
   {
    Unique_Key:localStorage.getItem('ampleUniquekey')
   }
  )
  changeScreen("mobileLogin")
 }

 const resendOTP = async () => {
  setResendOtpFlag(true);
  setTimer(20);
  setOtpError("");
  try {
   let res = await postCoreRequestAsync('/api/Consumer/requestOTP', { "MobileNo": mobileNumber, "ResendOTPRequest": "true", "CountryCode": "+91" })
   pushToAnalytics(
    'Basic info - Resend OTP',
    {
     Unique_Key:localStorage.getItem('ampleUniquekey')
    }
   )
  }
  catch (e) {
   setOtpError(e && (e.msg || e.message))
  }
 }
 const closeModal = () => {
  setShowModal(false);
  setOtpError("");
 }

 return (
  <Container fluid className="p-0 m-0 g-0" style={{ backgroundColor: 'rgb(255, 255, 255)', height: "100%" }}>
   <div style={{}} >
    <div style={{ padding: '24px' }}>
      <div className="verify-mobile-numer-str" style={{width:"100%", display:"flex", justifyContent:"center"}}>
        Verify Your Mobile Number
      </div>
      <div className="otp-text" style={{width:"100%", display:"flex", justifyContent:"center", fontSize:"0.8rem", marginTop:"4%"}}>
        <div className="paragraph_center paragraph_center-mobile"  style={{width:"70%"}}>Enter the 6 digit OTP sent on <br />  +91  - {mobileNumber} to verify</div>
        <div className="paragraph_center-desktop"  style={{width:"70%"}}>Enter the 6 digit OTP sent on +91  - {mobileNumber} to verify</div>
      </div>
      <div className="otp-bx" style={{width:"100%", display:"flex", justifyContent:"center", marginTop:"10%"}}>
       <MultiInput 
        label={"Enter OTP"}
        length={6} 
        handleOnChange={(e) => {
         setOTP(e);
         setOtpError("")
        }}
        classNames={{ input:'custom-input-class jost-font', message:'custom-msg-class' }}
       />
      </div>
      <div className='jost-font otp-resend' style={{width:"100%", display:"flex", justifyContent:"center", fontSize:"0.7rem", marginTop:"10%"}}>
      Did not receive an OTP? {otpTimer!==0?<span style={{marginLeft:"5px"}}>(Resend in 00:{otpTimer})</span>:""}
      </div>
      {otpTimer===0&&<div className="otp-resend-btn" style={{width:"100%", display:"flex", justifyContent:"center", marginTop:"10%"}}>
       <div  style={{fontSize:"0.8rem", fontWeight:"bolder", borderBottom: "1px solid black", cursor: "pointer"}} onClick={resendOTP}>Resend OTP</div>
      </div>}
    </div>
   </div>
   {  OtpError &&  <ErrorModal error={OtpError} showModal={showModal} closeModal={closeModal} onClick={closeModal} /> ||""}
 <div style={{paddingBottom:"10px"}}>
  <ButtonContainer
      isDisabled={OtpError || otp.length !== 6}
      BtnOneText={'Verify'}
      BtnTwoText={'Back'}
      onBtnOneClick={on_verify_btn_click}
      onBtnTwoClick={on_back_btn_click} 
      BtnOneClass={'pwa-continue-btn'}
      BtnTwoClass={'pwa-secondary-continue-btn'}/>
 </div>
 </Container>
 );
}
export default MobileOtpVerification;